import {
  clearStoredUtmParams,
  getStoredUtmParams,
  storeUtmParams,
  type UtmParams,
} from '@/stores/session-store';

const AUTH_REFERRAL_KEY = 'referral_code';
const LEGACY_AUTH_REFERRAL_KEY = 'zklogin_referral_code';
const UTM_KEYS: (keyof UtmParams)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

export const getUtmParamsFromSearch = (search: string): UtmParams => {
  const params = new URLSearchParams(search);
  const utmParams: UtmParams = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) utmParams[key] = value;
  }
  return utmParams;
};

export const storeAuthAttributionFromSearch = (search: string) => {
  const params = new URLSearchParams(search);
  const referralCode = params.get('irf') || params.get('referral') || params.get('ref');
  if (referralCode) storeReferralCode(referralCode);

  const utmParams = getUtmParamsFromSearch(search);
  if (Object.keys(utmParams).length) storeUtmParams(utmParams);
};

export const storeReferralCode = (referralCode: string) => {
  const normalized = referralCode.trim();
  if (normalized) localStorage.setItem(AUTH_REFERRAL_KEY, normalized);
};

export const clearReferralCode = () => {
  localStorage.removeItem(AUTH_REFERRAL_KEY);
  localStorage.removeItem(LEGACY_AUTH_REFERRAL_KEY);
};

export const getAuthAttribution = () => ({
  referralCode:
    localStorage.getItem(AUTH_REFERRAL_KEY) ?? localStorage.getItem(LEGACY_AUTH_REFERRAL_KEY),
  utmParams: getStoredUtmParams(),
});

export const clearAuthAttribution = () => {
  clearReferralCode();
  clearStoredUtmParams();
};

export const buildUrlWithUtmParams = (path: string, params: UtmParams | null) => {
  if (!params) return path;
  const search = new URLSearchParams(
    Object.entries(params).filter((entry): entry is [string, string] => Boolean(entry[1])),
  ).toString();
  return search ? `${path}?${search}` : path;
};

export const pushUtmToDataLayer = (params: UtmParams | null) => {
  const analyticsWindow = window as unknown as { dataLayer?: unknown[] };
  if (!params || !Array.isArray(analyticsWindow.dataLayer)) return;
  analyticsWindow.dataLayer.push({ event: 'utm_params_restored', ...params });
};
